import * as CANNON from 'cannon-es';

export class PhysicsWorld {
  public world: CANNON.World;
  private groundBody: CANNON.Body;

  constructor() {
    // 创建物理世界
    this.world = new CANNON.World({
      gravity: new CANNON.Vec3(0, -9.82, 0)
    });

    // 启用碰撞检测
    this.world.broadphase = new CANNON.NaiveBroadphase();
    this.world.solver.iterations = 10;

    // 设置求解器参数以提高性能
    this.world.defaultContactMaterial.friction = 0.3;
    this.world.defaultContactMaterial.restitution = 0.2;

    console.log('PhysicsWorld initialized with collision detection');

    // 创建地面
    const groundShape = new CANNON.Plane();
    this.groundBody = new CANNON.Body({
      mass: 0, // 质量为 0 表示静态物体
      shape: groundShape
    });
    this.groundBody.quaternion.setFromEuler(-Math.PI / 2, 0, 0);
    this.world.addBody(this.groundBody);
  }

  update(deltaTime: number): void {
    this.world.step(1 / 60, deltaTime, 3);
  }

  addBody(body: CANNON.Body): void {
    this.world.addBody(body);
  }

  removeBody(body: CANNON.Body): void {
    this.world.removeBody(body);
  }
}
